import React from 'react';

import { sendCrashEvent } from '@trello/error-reporting';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { PageError } from 'app/src/components/PageError';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderPage = (promise: Promise<any>) => {
  return promise.catch((error: Error) => {
    if (error.name === 'ChunkLoadError') {
      sendCrashEvent(error);
      const contentElement = document.getElementById('content');
      if (contentElement) {
        renderComponent(<PageError />, contentElement);
      }
    } else {
      throw error;
    }
  });
};
